import { render, staticRenderFns } from "./pageGap.vue?vue&type=template&id=f6e68d2c&scoped=true"
import script from "./pageGap.vue?vue&type=script&lang=ts"
export * from "./pageGap.vue?vue&type=script&lang=ts"
import style0 from "./pageGap.vue?vue&type=style&index=0&id=f6e68d2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e68d2c",
  null
  
)

export default component.exports